import { useEffect, useState } from "react";
import "css/FloatingWords.css";

import FloatingWord from "components/FloatingWord";

export default function FloatingWords({
  width = "40vw",
  children,
  words,
  setClear,
}) {
  const [floatingWords, setFloatingWords] = useState([]);
  const [floatingElements, setFloatingElements] = useState([]);

  useEffect(() => {
    const callback = () => setFloatingElements([]);
    setClear?.(() => callback);
  }, [setClear]);

  useEffect(() => {
    const newWords = JSON.parse(JSON.stringify(floatingWords));
    const newElements = floatingElements;

    let isChanged = false;
    words.forEach((word) => {
      if (!floatingWords.includes(word)) {
        isChanged = true;
        const element = <FloatingWord key={word} word={word} />;

        newWords.push(word);
        newElements.push(element);
      }
    });
    if (isChanged) {
      setFloatingWords(newWords);
      setFloatingElements(newElements);
    }
  }, [floatingElements, floatingWords, words]);

  return (
    <div>
      <div className="floatingWordsContainer" style={{ width }}>
        {floatingElements}
      </div>
      {children != null ? (
        <div className="floatingWordsChildrenContainer">{children}</div>
      ) : null}
    </div>
  );
}
